import { Component, computed, effect, input, signal } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { ITimer } from '../../icons/i-timer/i-timer';

@Component({
  selector: 'rid-timer',
  imports: [ITimer],
  templateUrl: './rid-timer.html',
  styleUrl: './rid-timer.css',
})
export class RidTimer {
  duration = input.required<number>();

  durationString = computed(() => {
    const minutes = Math.floor(this.duration() / 60);
    const seconds = this.duration() % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  });

  animationClass = signal('');

  constructor() {
    effect(() => {
      const dur = this.duration(); // track duration changes
      if (dur === 0) return;

      this.animationClass.set('pulse');
      delay(600).then(() => this.animationClass.set(''));
    });
  }
}
